import { z } from 'zod';

export const PricingOptionsZod = z.object({
    inheritParentOptions: z.boolean(),
    directInvoicing: z.boolean().optional(),
    coupon: z.string().optional(),
    couponName: z.string().optional(),
});

export type PricingOptions = z.infer<typeof PricingOptionsZod>;
